jQuery(document).ready(function ($) {
  // obecne
  var bodyWidth = window.innerWidth;

  // události při resize okna
  $(window).on('resize', function () {
    // osetreni, zda se velikost zmenila
    if (bodyWidth !== window.innerWidth) {
      // nastavíme novou šířku
      bodyWidth = window.innerWidth;
      // zresetuj menu
      resetMenu();
    }
  });

  // mobilní menu
  function switchMenu() {
    // označíme zda je menu zavřeno či nikoliv
    if ($('.nav__switcher').hasClass('is-open')) {
      $('.nav, .nav__switcher')
        .removeClass('is-open')
        .attr('aria-expanded', 'false');
    } else {
      $('.nav, .nav__switcher')
        .addClass('is-open')
        .attr('aria-expanded', 'true');
    }
  }
  // při změně rozlišení resetujeme menu
  function resetMenu() {
    $('.nav, .nav__switcher')
      .removeClass('is-open')
      .attr('aria-expanded', 'false');
  }
  // spouštěč
  $('.nav__switcher').on('click', function () {
    switchMenu();
  });
  // aria atributy k menu
  if (window.innerWidth < 992) {
    $('.nav, .nav__switcher').attr('aria-expanded', 'false');
  }

  // zavření filtrů (Filter Everything)
  if ($('.wpc-opened').length) {
    $('.wpc-opened').removeClass('wpc-opened').addClass('wpc-closed');
  }
});

//# sourceMappingURL=scripts.js.map
